<template>
  <div v-if="runs.length" class="mb-4" data-testid="rp-run-timeline">
    <SoTooltip v-for="run in runs" :key="run.id" :text="tooltipFor(run)">
      <a
        :href="rpLaunchUrl('fe-nova', run.id)"
        target="_blank"
        rel="noopener"
        class="mr-1 text-decoration-none"
        data-testid="rp-run-pill"
      >
        <SoChip :type="chipTypeFor(run)" :text="labelFor(run)" size="small" />
      </a>
    </SoTooltip>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoChip from "@/components/SoChip.vue"
  import SoTooltip from "@/components/SoTooltip.vue"
  import { SoChipType } from "@/types/components/SoChip"
  import { RpStatusService } from "@/services/admin/RpStatusService"
  import { rpLaunchUrl, RpLaunchRun } from "@/api/reportPortal/client"

  const LAUNCH_COUNT = 10

  export default defineComponent({
    components: { SoChip, SoTooltip },
    data() {
      return {
        runs: [] as RpLaunchRun[],
      }
    },
    async mounted() {
      const launches = await RpStatusService.getLaunches(LAUNCH_COUNT)
      if (launches && !launches.error) {
        this.runs = launches.runs
      }
    },
    methods: {
      rpLaunchUrl,
      pctFor(run: RpLaunchRun): number | null {
        const ran = run.total - run.skipped
        return ran > 0 ? Math.round((100 * run.passed) / ran) : null
      },
      labelFor(run: RpLaunchRun): string {
        if (run.status === "IN_PROGRESS") return `#${run.number} running`
        const pct = this.pctFor(run)
        return pct === null ? `#${run.number} —` : `#${run.number} ${pct}%`
      },
      chipTypeFor(run: RpLaunchRun): SoChipType {
        if (run.status === "IN_PROGRESS") return SoChipType.DEFAULT
        const pct = this.pctFor(run)
        if (pct === null) return SoChipType.DEFAULT
        if (pct === 100) return SoChipType.SUCCESS
        if (pct >= 95) return SoChipType.WARNING
        return SoChipType.ERROR
      },
      tooltipFor(run: RpLaunchRun): string {
        const when = run.startTime.slice(0, 16).replace("T", " ")
        return `run #${run.number} — ${run.passed} passed, ${
          run.failed
        } failed, ${run.skipped} skipped of ${run.total} · ${when} · by ${
          run.triggeredBy ?? "unknown"
        } · RP status ${run.status}`
      },
    },
  })
</script>
